<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/users/table">用户列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">赏金增加/减少</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="金额"
                          prop="credit">
              <el-input v-model="form.credit"></el-input>
            </el-form-item>
            <el-form-item label="原因"
                          prop="desc">
              <el-input v-model="form.desc"></el-input>
            </el-form-item>
            <el-form-item label="项目名"
                          prop="projectid">
              <el-select v-model="form.projectid"
                         filterable
                         remote
                         reserve-keyword
                         clearable
                         placeholder="请输入关键词"
                         :remote-method="remoteMethod"
                         :loading="loading">
                <el-option v-for="item in projectInfo"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../user-credit.rules.js'

export default {
  components: {},
  data () {
    return {
      formRules,
      loading: false,
      form: {
        userid: this.$route.params.userid,
        credit: '',
        desc: '',
        projectid: ''
      },
      projectInfo: []
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.update()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    update () {
      request.common('updateUserCredit', this.form).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/users/table/'})
        })
      })
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          request.alert('getProjectName', {keyword: query}).then(({data}) => {
            this.projectInfo = data
            this.loading = false
          })
        }, 500)
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/user-credit/pages/UserCreditForm.vue